import {Schedule} from "../settings/schedule/Schedule";

export const SettingsPage = () => {
  return (
    <Schedule />
  );
}

export default SettingsPage;